function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import EditorStatus from "./EditorStatus";
import EditorAction from "./EditorAction";
const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    zIndex: 3,
    top: "auto",
    right: 0,
    bottom: 0,
    left: 0,
    //        backgroundColor: theme.palette.primary.main,
    //        color: theme.palette.primary.contrastText,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: theme.spacing(7),
    fontSize: "16px",
    [theme.breakpoints.up('sm')]: {
      display: "none"
    }
  },
  status: {
    display: "flex",
    alignItems: "center",
    height: theme.spacing(5),
    minWidth: theme.spacing(14),
    justifyContent: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    fontSize: "14px",
    opacity: 0.5
  },
  action: {
    borderLeft: "1px solid",
    borderColor: "rgba(255,255,255,0.25)",
    "& > *": {
      height: theme.spacing(7)
    },
    "& button": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      height: theme.spacing(7),
      minWidth: theme.spacing(7)
    }
  }
}));

const EditorFooter = (_ref) => {
  let className = _ref.className,
      id = _ref.id,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 6 : _ref$elevation,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "id", "elevation"]);

  const classes = useStyles();
  return React.createElement(AppBar, {
    component: "footer",
    elevation: elevation,
    square: true,
    className: className || classes.root
  }, React.createElement(Toolbar, null, React.createElement(EditorStatus, _extends({}, props, {
    className: classes.status
  })), React.createElement(EditorAction, _extends({}, props, {
    className: classes.action
  }))));
};

export default EditorFooter;